import { createVueApp } from './app'

const { app, router } = createVueApp(window.__ALMANARA_INITIAL_CONTEXT__)

router.isReady().then(() => {
  app.mount('#app')
})
